/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Vehicle_Gps_Resolve_SuccessInputs */

const vi_vehicle_gps_resolve_success = /** @type {(inputs: Vehicle_Gps_Resolve_SuccessInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Đã kết nối IMEI với VnetGPS`)
};

/**

* @param {Vehicle_Gps_Resolve_SuccessInputs} inputs
* @param {{ locale?: "vi" }} options
* @returns {LocalizedString}
*/
export const vehicle_gps_resolve_success = /** @type {((inputs?: Vehicle_Gps_Resolve_SuccessInputs, options?: { locale?: "vi" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Vehicle_Gps_Resolve_SuccessInputs, { locale?: "vi" }, {}>} */ ((inputs = {}, options = {}) => {
	experimentalStaticLocale ?? options.locale ?? getLocale()
	return vi_vehicle_gps_resolve_success(inputs)
});